import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import IBDisabledEntry from 'components/IBDisabledEntry';
import { StorageRouteElement } from 'hooks/useStorageData';
import security from 'stores/security';
import History from './History';
import Detail from './History/Detail';
import List from './History/List';
import Introduce from './modules/Introduce';
import { Broker, Check, ChooseTransferType, PartialDetails, Preview, Result, StepLayout } from './modules/Steps';
import EditBroker from './modules/Steps/Edit/Broker';
import EditCheck from './modules/Steps/Edit/Check';
import { FillCash, FillFund, FillOption, FillStock } from './modules/Steps/PartialDetails';
import './style.scss';

// 转股（转户）
const Transfer = () => {
    if (!security.isMarscoAccount) {
        return (
            <Card page>
                <IBDisabledEntry />;
            </Card>
        );
    }

    return (
        <Card page className="transfer-root">
            <AnimatedRouter timeout={300}>
                <Route path="*" element={<StorageRouteElement cacheKey="TRANSFER_MODULE" />}>
                    <Route path="introduce" element={<Introduce />} />
                    <Route path="step" element={<StepLayout />}>
                        <Route path="broker" element={<Broker />} />
                        <Route path="check" element={<Check />} />
                        <Route path="type" element={<ChooseTransferType />} />
                        <Route path="preview" element={<Preview />} />
                        <Route path="result" element={<Result />} />
                        <Route path="partial-details" element={<PartialDetails />} />
                        <Route path="fill-cash" element={<FillCash />} />
                        <Route path="fill-stock" element={<FillStock />} />
                        <Route path="fill-option" element={<FillOption />} />
                        <Route path="fill-fund" element={<FillFund />} />
                        <Route path="edit">
                            <Route path="broker" element={<EditBroker />} />
                            <Route path="check" element={<EditCheck />} />
                            <Route path="*" element={<Navigate to="broker" replace />} />
                        </Route>
                        <Route path="*" element={<Navigate to="broker" replace />} />
                    </Route>
                    <Route path="history" element={<History />}>
                        <Route index element={<List />} />
                        <Route path=":id" element={<Detail />} />
                        <Route path="*" element={<Navigate to=".." replace />}></Route>
                    </Route>
                    <Route path="*" element={<Navigate replace to="introduce" />} />
                </Route>
            </AnimatedRouter>
        </Card>
    );
};

export default Transfer;
